import React, { Component } from 'react';
import { Upload, Button, Modal, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

class UploadFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            loading: false,
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileList: [],
            value: null,
        };
        this.inputChange = this.inputChange.bind(this);
        this.inputBlur = this.inputBlur.bind(this);
    }

    // componentDidMount() {
    //     this.setState((state) => ({ 'selectdata': this.props.selectdata }));
    //     console.log(this.props.selectdata);
    // }

    // componentDidUpdate(prevProps, pervState) {
    //     if (prevProps.selectdata.value != this.props.selectdata.value) {
    //         this.setState((state) => ({ 'selectdata': this.props.selectdata }));
    //     }
    // }


    inputChange(value) {
        console.log(value.fileList);
        let { feild_data } = this.props;
        this.setState({ 'value': value.fileList }, () => {
            this.inputBlur();
        });
    }

    inputBlur() {
        let { value, error } = this.state;
        let { feild_data } = this.props;
        feild_data['value'] = value;
        feild_data['error'] = error;
        this.props.inputChange(feild_data)
    }

    render() {
        let { feild_data } = this.props;
        let { value } = this.state;

        const props = {
            name: 'file',
            multiple: true,
            action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            onChange(info) {
                const { status } = info.file;
                if (status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully.`);
                } else if (status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };
        return (
            // <div className="clearfix">
               
                <Dragger {...props} name={feild_data.name} onChange={this.inputChange} onBlur={this.inputBlur}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                        band files
                    </p>
                </Dragger>
            // </div>
        );
    }
}

export default UploadFile;